import en from '../assets/languages/en-us.json';
import { type LanguageCode, type MessageCatalog } from './types';

// Only the 8 translation files. English is imported above. A file that is
// not in the tree yet is simply absent, and the loader falls back to English.
const loaders = import.meta.glob('../assets/languages/{es,fr,de,it,pt-BR,pt-PT,pl,he}.json', {
  import: 'default',
}) as Record<string, () => Promise<MessageCatalog>>;

const FILE: Record<Exclude<LanguageCode, 'en'>, string> = {
  es: '../assets/languages/es.json',
  fr: '../assets/languages/fr.json',
  de: '../assets/languages/de.json',
  it: '../assets/languages/it.json',
  'pt-BR': '../assets/languages/pt-BR.json',
  'pt-PT': '../assets/languages/pt-PT.json',
  pl: '../assets/languages/pl.json',
  he: '../assets/languages/he.json',
};

const cache = new Map<LanguageCode, MessageCatalog>();
cache.set('en', en);

/** English is synchronous. A language file that is not in the build falls back to English. */
export async function loadCatalog(code: LanguageCode): Promise<MessageCatalog> {
  const hit = cache.get(code);
  if (hit) return hit;
  if (code === 'en') return en;
  const loader = loaders[FILE[code]];
  if (!loader) return en;
  const catalog = await loader();
  cache.set(code, catalog);
  return catalog;
}

export const englishCatalog: MessageCatalog = en;
